<div class="machine-translation">
  <p class="text-sm text-600 mt-0 mb-3 hint" data-clarity-unmask="true">
    Katalog ministerstwa nie ma wersji ukraińskiej tych pytań. Zaznacz pytania i kliknij „Przetłumacz zaznaczone” –
    DeepL jednorazowo uzupełni puste pola UA (teksty polskie, angielskie i niemieckie zostają bez zmian). Tłumaczenie
    można potem poprawić: „Szczegóły” → „Edytuj”. Kursant przy każdym takim pytaniu widzi ikonkę
    „Tłumaczenie nieoficjalne” z informacją, że ministerstwo nie dostarcza tłumaczenia. Import katalogu z wersją
    ministerstwa podmienia nasze tłumaczenie i zdejmuje ikonkę.
  </p>

  @if (error(); as message) {
    <div class="error-banner" role="alert">
      <i class="pi pi-exclamation-triangle"></i>
      <span>{{ message }}</span>
    </div>
  }

  @if (status(); as s) {
    @if (!s.deepLEnabled) {
      <div class="error-banner" role="alert" data-clarity-unmask="true">
        <i class="pi pi-exclamation-triangle"></i>
        <span>Integracja z DeepL jest wyłączona albo nie ma klucza API. Włącz ją w „Ustawienia platformy → Integracje → DeepL”.</span>
      </div>
    }
  }

  <div class="toolbar mb-3">
    <div class="toolbar-group">
      <p-selectButton
        [options]="viewOptions"
        [ngModel]="view"
        (ngModelChange)="onViewChange($event)"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        styleClass="view-switch"
        data-clarity-unmask="true"
      ></p-selectButton>
      <p-button
        [label]="'Zaznacz wszystkie bez tłumaczenia (' + missingCount + ')'"
        icon="pi pi-check-square"
        [outlined]="true"
        size="small"
        [disabled]="missingCount === 0"
        (onClick)="selectAllMissing()"
        data-clarity-unmask="true"
      />
    </div>
    <div class="toolbar-group toolbar-group--end">
      <span class="selection-info text-sm" data-clarity-unmask="true">
        @if (selected.length) {
          Zaznaczone: <strong>{{ selected.length }}</strong>
          @if (toTranslate.length !== selected.length) {
            <span class="text-600"> (do tłumaczenia {{ toTranslate.length }})</span>
          }
          @if (toTranslate.length) {
            <span class="text-600"> · ok. {{ formatNumber(estimatedCharacters) }} znaków</span>
          }
        } @else {
          <span class="text-600">Zaznacz pytania w tabeli</span>
        }
      </span>
      @if (selected.length) {
        <p-button icon="pi pi-times" [text]="true" size="small" pTooltip="Wyczyść zaznaczenie" tooltipPosition="bottom" ariaLabel="Wyczyść zaznaczenie" (onClick)="clearSelection()" data-clarity-unmask="true" />
      }
      <p-button
        [label]="toTranslate.length ? 'Przetłumacz zaznaczone (' + toTranslate.length + ')' : 'Przetłumacz zaznaczone'"
        icon="pi pi-language"
        [disabled]="!canTranslate"
        [loading]="starting()"
        [pTooltip]="!deepLEnabled ? 'Najpierw włącz DeepL w ustawieniach platformy' : isRunning ? 'Poczekaj, aż skończy się bieżące tłumaczenie' : ''"
        tooltipPosition="bottom"
        (onClick)="askToTranslate()"
        data-clarity-unmask="true"
      />
    </div>
  </div>

  @if (status(); as s) {
    @if (s.state !== 'Idle') {
      <div class="status-card mb-3">
        <div class="flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
          <div class="flex align-items-center gap-3 flex-wrap">
            <span class="font-semibold" data-clarity-unmask="true">Ostatnie tłumaczenie</span>
            <span class="state-badge" [ngClass]="stateClass(s)" data-clarity-unmask="true">
              <i class="pi" [ngClass]="isRunning ? 'pi-spin pi-spinner' : s.state === 'Failed' ? 'pi-times-circle' : s.state === 'Completed' ? 'pi-check-circle' : 'pi-info-circle'"></i>
              {{ stateLabel(s) }}
            </span>
            <span class="text-sm text-600">
              {{ formatDateTime(s.startedAt) }}{{ s.startedByEmail ? ', ' + s.startedByEmail : '' }} · {{ scopeLabel(s) }}
            </span>
          </div>
          <div class="flex align-items-center gap-2">
            @if (isRunning) {
              <p-button label="Zatrzymaj" icon="pi pi-stop" severity="danger" [outlined]="true" size="small" [loading]="stopping()" (onClick)="stop()" data-clarity-unmask="true" />
            }
            <p-button icon="pi pi-refresh" [outlined]="true" size="small" pTooltip="Odśwież stan" tooltipPosition="left" [loading]="loadingStatus()" (onClick)="loadStatus()" data-clarity-unmask="true" />
          </div>
        </div>

        <div class="progress-section">
          <div class="flex justify-content-between text-sm mb-1">
            <span>
              {{ s.processedQuestions }} z {{ s.totalQuestions }} pytań
              @if (s.currentQuestionNumber) {
                <span class="text-600"> · pytanie nr {{ s.currentQuestionNumber }}</span>
              }
            </span>
            <span class="font-semibold">{{ s.progressPercentage }}%</span>
          </div>
          <p-progressBar [value]="s.progressPercentage" [showValue]="false" styleClass="translation-progress"></p-progressBar>
        </div>

        <div class="run-counts text-sm">
          <span><i class="pi pi-check text-green-600"></i> przetłumaczone: <strong>{{ s.translatedQuestions }}</strong></span>
          <span><i class="pi pi-minus-circle text-600"></i> pominięte: <strong>{{ s.skippedQuestions }}</strong></span>
          <span [class.text-red-600]="s.failedQuestions > 0"><i class="pi pi-exclamation-circle"></i> błędy: <strong>{{ s.failedQuestions }}</strong></span>
          <span><i class="pi pi-align-left text-600"></i> znaków wysłanych do DeepL: <strong>{{ formatNumber(s.charactersSent) }}</strong></span>
        </div>

        @if (s.state === 'Failed') {
          <div class="error-banner mt-2 mb-0" role="alert">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ s.errorMessage || 'Tłumaczenie przerwane. Szczegóły w logu serwera.' }} Pytania przetłumaczone do tej pory zostały zapisane.</span>
          </div>
        }

        @if (s.errors.length) {
          <p-panel [header]="'Błędy (' + s.failedQuestions + ')'" [toggleable]="true" [collapsed]="true" styleClass="list-panel list-panel--errors mt-2">
            <ul class="error-list"><li *ngFor="let e of s.errors">{{ e }}</li></ul>
          </p-panel>
        }
      </div>
    }
  }

  <fas-services-table
    class="table-height"
    scrollHeight="flex"
    [value]="questions"
    [columns]="columns"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    [paginator]="true"
    [showCheckbox]="true"
    [selection]="selected"
    (selectionChange)="onSelectionChange($event)"
    dataKey="guid"
    [loading]="loading"
    [showCurrentPageReport]="true"
    [showFooterPageReport]="false"
    customResultsName="pytań"
  >
    <ng-template #questionCell let-q>
      <div class="question-text text-sm" [title]="q.question || ''">{{ q.question }}</div>
      <button type="button" class="white-button details-button" (click)="details(q)" data-clarity-unmask="true">
        Szczegóły<i class="pi pi-arrow-right"></i>
      </button>
    </ng-template>
    <ng-template #uaCell let-q>
      @if (q.questionUA) {
        <div class="question-text text-sm" [title]="q.questionUA">{{ q.questionUA }}</div>
      } @else {
        <span class="text-sm text-400">—</span>
      }
    </ng-template>
    <ng-template #stateCell let-q>
      @if (rowState(q); as state) {
        <span class="row-state" [ngClass]="state.css" [pTooltip]="state.detail" tooltipPosition="left" data-clarity-unmask="true">{{ state.label }}</span>
      }
    </ng-template>
  </fas-services-table>
</div>

<p-dialog
  header="Przetłumaczyć zaznaczone pytania?"
  [(visible)]="confirmVisible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '520px' }"
>
  <p class="mt-0 text-sm" data-clarity-unmask="true">
    DeepL przetłumaczy na ukraiński <strong>{{ toTranslate.length }} {{ questionsWord(toTranslate.length) }}</strong>
    (ok. {{ formatNumber(estimatedCharacters) }} znaków; plan DeepL Free to 500 000 znaków miesięcznie).
    @if (selected.length !== toTranslate.length) {
      Pozostałe zaznaczone ({{ selected.length - toTranslate.length }}) mają już tłumaczenie i zostaną pominięte.
    }
  </p>
  <p class="text-sm mb-0" data-clarity-unmask="true">
    Tłumaczenie trafi do pustych pól UA i od razu zobaczą je kursanci – z ikonką „Tłumaczenie nieoficjalne”.
    Poprawić je można w szczegółach pytania.
  </p>
  <ng-template pTemplate="footer">
    <p-button label="Anuluj" [text]="true" (onClick)="confirmVisible = false" />
    <p-button label="Przetłumacz" icon="pi pi-language" (onClick)="translateSelected()" data-clarity-unmask="true" />
  </ng-template>
</p-dialog>
